// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/umweltmanagement-preis-2023-fuer-dietz-gmbh-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const umweltmanagementPreis2023FuerDietzGmbh2DE: PageEntry = {
  id: "post.umweltmanagement-preis-2023-fuer-dietz-gmbh-2",
  locale: "de",
  slug: "umweltmanagement-preis-2023-fuer-dietz-gmbh-2",
  seo: {
    title: "Umweltmanagement-Preis 2023 für DIETZ GmbH | Dietz GmbH",
    description: "Umweltmanagement-Preis 2023 für DIETZ GmbH",
  },
  type: "post",
  h1: "Umweltmanagement-Preis 2023 für DIETZ GmbH",
  blocks: [
    { kind: "heading", level: 2, text: "Umweltmanagement-Preis 2023 für DIETZ GmbH" },
    { kind: "paragraph", text: "Am 8. November wurden siebzehn Unternehmen und Organisationen aus Deutschland und Österreich mit dem Umweltmanagement-Preis 2023 ausgezeichnet. Der feierlichen Preisverleihung im Bundesumweltministerium Berlin vorangestellt war eine Fachkonferenz, auf der aktuelle Herausforderungen und Zielkonflikte in der nachhaltigen Unternehmensentwicklung diskutiert wurden." },
    { kind: "paragraph", text: "Die DIETZ GmbH wurde ausgezeichnet für: „Beste Strategie für eine nachhaltige Unternehmensentwicklung“" },
    { kind: "paragraph", text: "Weitere Informationen entnehmen Sie der Pressemitteilung des UGA Umweltgutachterausschuss und EMAS ." }
  ],
};
